//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[[0,"EnableSmartFilter",1,0],[0,"FilterType",1,0],[0,"MappingPropertyForExcelData",1,0],[0,"MappingPropertyForMechanicalData",1,0],[0,"PropertyName",1,0],[0,"ShowObjectsSetting",1,0],[0,"TypeMappingModeForExcelData",1,0],[0,"TypeMappingModeForMechanicalData",1,0]],[[["rowsNum"],"GetFilterValues",{R_:{filterValues:""}},0,0],[["filterValues"],"SetFilterValues",{},1,0]],[]];
SPLM.AME.CollaborationProjectSettingsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.CollaborationProjectSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.CollaborationProjectSettingsBuilder.FilterMode = Object.freeze({
    "FilterOnClassificationClass" : "FilterOnClassificationClass", "FilterOnProperty" : "FilterOnProperty"});

SPLM.AME.CollaborationProjectSettingsBuilder.ResultsSetting = Object.freeze({
    "DefineFilterValues" : "DefineFilterValues", "ShowObjectsIfNotEmpty" : "ShowObjectsIfNotEmpty"});

export default SPLM;